var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconMail = function SvgIconMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.886 3.75a1.61 1.61 0 0 1 1.598 1.373l.012.112.004.111v8.058c0 .8-.6 1.47-1.388 1.58l-.114.012-.112.004H3.114a1.61 1.61 0 0 1-1.598-1.373l-.012-.112-.004-.111V5.346c0-.8.6-1.47 1.388-1.58l.114-.012.112-.004h11.772zm.196 2.684-5.618 4.814a.712.712 0 0 1-.759.107l-.091-.05-.078-.057-5.62-4.814v6.97c0 .077.047.145.11.175l.04.014.048.005h11.772a.2.2 0 0 0 .178-.108l.014-.04.005-.046-.001-6.97zm-.67-1.282H3.587l5.412 4.637 5.413-4.637z",
    fill: "#FA5851",
    fillRule: "evenodd"
  })));
};

export default SvgIconMail;